import FiltersExposed from './FiltersExposed';

export default FiltersExposed;
